import api from '@pray/shared/utils/api';

type CreateSlotAssignmentParams = {
  artistId: string;
  slotTime: string;
  recurrenceType: 'once' | 'daily' | 'weekly' | 'every_x_days';
  recurrenceDayOfWeek?: number | null;
  recurrenceInterval?: number | null;
  startDate: string;
  endDate?: string | null;
};

export async function createPrayRadioSlotAssignment({
  artistId,
  slotTime,
  recurrenceType,
  recurrenceDayOfWeek,
  recurrenceInterval,
  startDate,
  endDate,
}: CreateSlotAssignmentParams) {
  if (!artistId) throw Error('Artist ID is required');
  if (!slotTime) throw Error('Slot Time is required');
  if (!recurrenceType) throw Error('Recurrence Type is required');
  if (!startDate) throw Error('Start Date is required');

  const url = '/web/studio/pray-radio/slot-assignments';
  const response = await api.executePostRequest(url, {
    artist_id: artistId,
    slot_time: slotTime,
    recurrence_type: recurrenceType,
    recurrence_day_of_week: recurrenceDayOfWeek ?? null,
    recurrence_interval: recurrenceInterval ?? null,
    start_date: startDate,
    end_date: endDate ?? null,
  });

  return response.data;
}
